var map = {
	"./avatar_calculator.png": "f3b1",
	"./avatar_ireliacarriesu.png": "d216",
	"./avatar_matafe_.png": "e920",
	"./avatar_mero.png": "3e96",
	"./avatar_rocketsledge.png": "78db",
	"./avatar_souless.png": "b5e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "84bf";